import { Constants } from '../constants/constants';
import { Injectable } from '@angular/core';
import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';

import { Observable, of, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

import Swal from 'sweetalert2/dist/sweetalert2.all.js'; //CAMBIA EN PROXIMAS VERSIONES EN ESTA DEBE IMPORTARSE ASI
import { Utils } from '../utils/utils';



@Injectable({
  providedIn: 'root'
})
export class GraficasService {

  constructor(
    private http: HttpClient,
    private utils:Utils
  ) { }

  public getGrafica(grafica: string): Observable<any> {
    let url = Constants.BASE_URL + Constants.URL_GRAFICAS_INICIO + grafica;
    return this.http.get<any>(url)
      .pipe(
        catchError(err => {
          if (err.status === 401) {
            this.utils.cerrarSesion();
          } else {
            Swal.fire({
              title: 'Error Graficas',
              text: 'Error Cargando Graficas.',
              type: 'error'
            });
          }
          return throwError(err);
        })
      )
  }

  public getGraficaEntregadoresStacked(agencias, tipo): Observable<any> {
    let url = Constants.BASE_URL + Constants.URL_GRAFICA +'/'+ agencias+'/'+tipo;
    return this.http.get<any>(url)
      .pipe(
        catchError(err => {
          /*swal(
            'Error Graficas',
            JSON.stringify(err),
            'error'
          );*/
          if (err.status === 401) {
            this.utils.cerrarSesion();
          } else {
            Swal.fire({
              title: 'Error Graficas',
              text: 'Error Cargando Graficas.',
              type: 'error'
            });
          }
          return throwError(err);
        })
      )
  }

}